import React from 'react';
import { Popover, OverlayTrigger, Button, Container } from 'react-bootstrap'
import Paragraph from './Paragraph';

const ChoiceTableItem = (props) => {
  // Popover-ikkuna, jossa valintavihjeet esitellään hoverin/focuksen kautta
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">{props.data.hintHeader}</Popover.Header>
      <Popover.Body>
        {props.data.hintText}
      </Popover.Body>
    </Popover>
  )

  // Pakottaa popoverin vasemmalle pienissä näytöissä
  const initPlacement = () => {
    if(window.innerWidth < 1000){
      return "left"
    } else {
      return props.popoverDirection
    }
  }

  return (
      <Button id={ props.data.id + '-choice' + props.value } name="choice" role="option" className={ props.choice === props.value? "choice choiceSelected " + props.data.colorClass : "choice " + props.data.colorClass } value={ props.value } onClick={ (e) => props.handleSelect(e) } aria-selected={props.choice === props.value? true : false} tabIndex="0" >
        { props.data.text }
        <OverlayTrigger trigger={['hover', 'focus']} placement={initPlacement()} overlay={popover}>
          <Container className="choiceQuestion" tabIndex="0"><Paragraph classes="choiceInfo" text={"?"} /></Container>
        </OverlayTrigger>
      </Button>
  );
};

export default ChoiceTableItem;